// extracted by mini-css-extract-plugin
export default {"container":"loader_container__jxcVG","fade_out":"loader_fade_out__v0SuJ","loader":"loader_loader__iMeaf","wave":"loader_wave__EdvJb"};